import React from "react";

interface Props {
    tableRow?: any;
}

const DataTable = (props: Props) => {
    const tableHeader = ["name", "value", "value2", "value3", "value4"];
    const tableRow = ["Tomkart", "30 minutes", "3 Adult / 2 Child", "16 Rides", "360 Fr."];

    const DataTableRow = props => {
        const {className} = props;

        const items = props.tableRow; //props.children or whatever from database
        return (
            <tr className={className}>
                {items.map((item, index) => (
                    <td key={index} className="px-6 py-4 whitespace-nowrap">
                        {item}
                    </td>
                ))}
            </tr>
        );
    };

    const DataTableHead = props => {
        const items = tableHeader; //props.children or whatever from database
        return (
            <tr>
                {items.map((item, index) => (
                    <th key={index} className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" scope="col">
                        {item}
                    </th>
                ))}
            </tr>
        );
    };

    return (
        <div className="flex flex-col col-span-2 w-full">
            <div className="-my-2 overflow-x-auto ">
                <div className="py-2 align-middle inline-block w-full">
                    <div className="shadow overflow-hidden border border-gray-100 sm:rounded-lg">
                        <table className="w-full divide-y divide-gray-200">
                            <thead className="bg-gray-100">
                                <DataTableHead>{tableHeader}</DataTableHead>
                            </thead>

                            <tbody className="bg-white divide-y divide-gray-200">
                                <DataTableRow className={"bg-gray-50"} tableRow={tableRow} />
                                <DataTableRow tableRow={tableRow} />
                                <DataTableRow className={"bg-gray-50"} tableRow={tableRow} />
                                <DataTableRow tableRow={tableRow} />
                                <DataTableRow className={"bg-gray-50"} tableRow={tableRow} />
                                <DataTableRow tableRow={tableRow} />
                                <DataTableRow className={"bg-gray-50"} tableRow={tableRow} />
                                <DataTableRow tableRow={tableRow} />
                                <DataTableRow className={"bg-gray-50"} tableRow={tableRow} />
                                <DataTableRow tableRow={tableRow} />
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DataTable;
